import * as yup from 'yup';
import { IFormField } from '../../../../../extViewmodels';
import { IPublicFileAttachment } from '../../../../models/Api';

export const SURVEY_FILE_INPUT_MAX_FILES = 5;

export const acceptedFileTypes = [
	// Documents
	'application/pdf',
	'application/msword',
	'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
	'text/plain',
	'text/markdown',
	'text/csv',
	'application/vnd.ms-excel',
	'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
	// Images
	'image/jpeg',
	'image/png',
	'image/gif',
	'image/bmp',
	'image/webp',
];

export const buildFileYupSchema = (field: IFormField<string>) => {
	let baseSchema = yup
		.array()
		.of(yup.mixed<IPublicFileAttachment>())
		.max(SURVEY_FILE_INPUT_MAX_FILES, `${field.label} can only have up to ${SURVEY_FILE_INPUT_MAX_FILES} files`);

	baseSchema = field.isOptional
		? baseSchema.optional()
		: baseSchema.min(1, `${field.label} is required`).required(`${field.label} is required`);

	return baseSchema;
};
